
<template>
  <div class="mailbox-settings-auto-responder-response">
    <i class="ddi ddi-auto-responder" />
    <div :class="{'disabled': hasNoUseCases(autoResponse)}" class="mailbox-settings-auto-responder-response__info">
      <span>
        {{ autoResponse.subject }}
      </span>
      <div v-if="hasNoUseCases(autoResponse)">
        Disabled
      </div>
      <div v-else>
        {{ autoResponse.useCaseDescription }}
      </div>
    </div>
    <div class="mailbox-settings-auto-responder-response__actions">
      <dd-icon-button 
        :is-disabled="disabled" 
        icon="edit"
        type="rounded"
        size="medium"
        color="grey"
        @click="edit" 
      />
      <dd-icon-button 
        :is-disabled="disabled" 
        danger
        icon="trash"
        type="rounded"
        size="medium"
        color="grey"
        @click="remove" 
      />
    </div>
  </div>
</template>


<script lang="ts">
import { defineComponent } from 'vue'
import { IAutoResponse, IItemForSelection } from '@/api/types/response.types'

export default defineComponent({
  name: 'MailboxSettingsAutoResponderResponse',

  props: {
    index: {
      type: Number,
      default: 0,
    },
    autoResponse: {
      type: Object as () => IAutoResponse,
      required: true,
    },
    useCaseTypes: {
      type: Array as () => IItemForSelection[],
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['edit', 'remove'],
  methods: {
    edit(): void {
      this.$emit('edit', this.index)
    },
    remove(): void {
      this.$emit('remove', this.index)
    },
    getUseCaseName(id: number): string {
      return this.useCaseTypes.find(u => u.id === id).name
    },
    hasAnyUseCases(autoResponse: IAutoResponse): boolean {
      return autoResponse.listUseCaseTypeIDs.length > 0
    },
    hasAllUseCases(autoResponse: IAutoResponse): boolean {
      return !this.useCaseTypes.find(
        u => !autoResponse.listUseCaseTypeIDs.includes(u.id),
      )
    },
    hasNoUseCases(autoResponse: IAutoResponse): boolean {
      return !this.hasAnyUseCases(autoResponse)
    },
  },
})
</script>

<style lang="scss">
.mailbox-settings-auto-responder-response {
  display: flex;
  align-items: center;
  padding: 12px 0;

  &:not(:last-child) {
    border-bottom: $border--solid-extra-light;
  }

  > i {
    color: var(--color-text-third);
  }

  &__info {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    margin: 0 10px;

    &.disabled {
      color: var(--color-text-third);
    }

    > span {
      font-weight: $bold;
    }

    > div {
      @include lettering--p-sm--no-color;
    }
  }

  &__actions {
    display: flex;
    margin-left: auto;

    > :last-child {
      margin-left: 8px;
    }
  }
}
</style>
